import { jsx as _jsx } from "react/jsx-runtime";
import clsx from "clsx";
export function Center({ className, children }) {
    return (_jsx("div", { className: clsx('flex items-center justify-center', className), children: children }));
}
//# sourceMappingURL=Center.js.map